import {Component, Inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {User, Account, UserRole} from "src/app/auth/auth.model";
import {i18nService} from "src/app/service-utils/i18n.service";
import {AccountsApiService} from "../../../api/accounts-api.service";
import {
  confirmPasswordValidator, passwordValidator,
  requiredFieldValidator
} from "../../../utils/validation/validators";

@Component({
  selector: 'app-user-super-admin-dialog',
  templateUrl: './user-super-admin-dialog.component.html',
  styleUrls: ['./user-super-admin-dialog.component.scss']
})
export class UserSuperAdminDialogComponent implements OnInit {
  form: FormGroup;
  customerNames: string[];
  accounts: Account[];
  UserRole = UserRole;

  constructor(
    public dialogRef: MatDialogRef<UserSuperAdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public i18nService: i18nService,
    private formBuilder: FormBuilder,
    private accountsApi: AccountsApiService
  ) {
  }

  ngOnInit(): void {
    this.accountsApi.getAll().subscribe(accounts => {
      if (accounts != undefined) {
        this.accounts = accounts;
        this.customerNames = accounts.map(account => account.customerName + " " + account.customerNumber)
          .sort((a, b) => a.localeCompare(b, 'en', {sensitivity: 'base'}));
      }
    });
    this.form = this.formBuilder.group({
      username: [this.data?.item.username, requiredFieldValidator()],
      fullName: [this.data?.item.fullName, requiredFieldValidator()],
      role: [((this.data?.item?.role === this.UserRole.ADMIN) ? this.UserRole.ADMIN : this.UserRole.USER), requiredFieldValidator()],
      password: [null, [requiredFieldValidator(), passwordValidator]],
      confirmPassword: [null, [requiredFieldValidator(), passwordValidator]],
      customerName: [this.data?.item.account.customerName + " " + this.data?.item.account.customerNumber, requiredFieldValidator()]
    }, {
      validator: confirmPasswordValidator
    });

  }

  discard(): void {
    this.dialogRef.close();
  }

  save(): any {
    event.stopPropagation();

    this.form.get('username').markAsTouched();
    this.form.get('fullName').markAsTouched();
    this.form.get('password').markAsTouched();
    this.form.get('confirmPassword').markAsTouched();
    this.form.get('customerName').markAsTouched();

    if (this.form.valid) {
      if (this.data?.item.username && this.form.get("password").value !== null && this.form.get("password").value.trim() === '') {
        this.form.get("password").setValue(null);
      }
      let newUser: User = {
        id: null,
        account: this.accounts.find(account => (account.customerName + " " + account.customerNumber) === this.form.get("customerName").value),
        username: this.form.get("username").value,
        fullName: this.form.get("fullName").value,
        role: this.form.get("role").value,
        password: this.form.get("password").value,
      };
      if (this.data) {
        newUser.id = this.data.item.id;
      }
      this.dialogRef.close({data: newUser});
    }
  }
}
